import React from 'react'
import {changeYearInIsoDateString, toUkDateString} from '../../../search/MemorableDate'
import {Link} from 'react-router-dom'
import {WithPermission} from '../../../auth/AccessConditionals'

/**
 * Following ES6 modules work in the context of react-scripts only, that depend on Webpack.
 * If they need to be used in CommonJS environment then refactor to use React.createClass
 */

export const CaseDetails = ({model, ...rest}) => {
  const NHS = () => {
    return (
      <>
        NHS no: {model.nhsNumber}
        <WithPermission name="case:read">
          &nbsp;(
          <Link to={`/cases/search?caseRef=person_1&nhsNumber=${model.nhsNumber}`}>Search using NHS number</Link>)
        </WithPermission>
      </>
    )
  }

  return (
    <div {...rest}>
      <address>
        Name: {model.name}
        <br />
        Date of birth: {toUkDateString(model.dob)}
        <br />
        Usual address: {model.address}
        <br />
        Telephone number: {model.phone}
        <br />
        {model.nhsNumber && <NHS />}
      </address>
      <WithPermission name="case:read">
        <SimilarCasesLink model={model} />
      </WithPermission>
    </div>
  )
}

const SimilarCasesLink = ({model}) => {
  const dobMinus5 = changeYearInIsoDateString(model.dob, -5)
  const dobPlus5 = changeYearInIsoDateString(model.dob, 5)
  const addressShortened = (model.address ? model.address + '' : '')
    .split(/[^A-Z]+/gi)
    .reduce((memo, val, idx) => (idx < 3 && !!val ? `${memo} ${val}` : memo), '')

  return (
    <Link
      to={`/cases/search?caseRef=person_1&name=${model.name}&dobafter=${dobMinus5}&dobbefore=${dobPlus5}&address=${addressShortened}`}
      className="btn btn-sm btn-outline-secondary"
    >
      Search for possible duplicates
    </Link>
  )
}

export {HomePageContent} from './HomePageContent'
export {AboutPageContent} from './AboutPageContent'
